import { PatientTitleProps } from "src/types/case";

export const DEFAULT_DRUG_ID = 119717;

export const PATIENT_TITLE: readonly PatientTitleProps[] = [
  {
    label: 'Mr.',
    value: 'mr',
  },
  {
    label: 'Ms.',
    value: 'ms',
  },
  {
    label: 'Mrs.',
    value: 'mrs',
  },
  {
    label: 'Miss',
    value: 'miss',
  },
];

export const PATIENT_GENDER: PatientTitleProps[] = [
  {
    label: 'Male',
    value: 'M',
  },
  {
    label: 'Female',
    value: 'F',
  },
];

export const PATIENT_TIME_TO_CONTACT: PatientTitleProps[] = [
  {
    label: 'Morning',
    value: 'morning',
  },
  {
    label: 'Afternoon',
    value: 'afternoon',
  },
  {
    label: 'Evening',
    value: 'evening',
  },
];

export const PATIENT_PHONE_TYPES: PatientTitleProps[] = [
  {
    label: 'Cell',
    value: 'cell',
  },
  {
    label: 'Home',
    value: 'home',
  },
  {
    label: 'Work',
    value: 'work',
  },
];

export const PATIENT_ADDR_TYPES: PatientTitleProps[] = [
  {
    label: 'Home',
    value: 'home',
  },
  {
    label: 'Work',
    value: 'work',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const PATIENT_INSURANCE_TYPE: PatientTitleProps[] = [
  {
    label: 'Self',
    value: 'self',
  },
  {
    label: 'Spouse',
    value: 'spouse',
  },
  {
    label: 'Parent / Guardian',
    value: 'guardian',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const PATIENT_SITE_TYPE: PatientTitleProps[] = [
  {
    label: '11-Physician office/clinic',
    value: 'office',
  },
  {
    label: '24-Ambulatory Surgery Center',
    value: 'asc',
  },
  {
    label: '22-Hospital Outpatient Department (On-campus)',
    value: 'hospital',
  },
  {
    label: '19-Hospital Outpatient Department (Off-campus)',
    value: 'hospital-off',
  },
];

export const PATIENT_PHARMACY_INSTRUCTIONS: PatientTitleProps[] = [
  {
    label: 'Initial Course - 5 Refills',
    value: 'standard'
  },
  {
    label:'Maintenance Course - 10 Refills',
    value: 'maintenance'
  },
  {
    label: 'Initial Course Bilateral - 5 Refills',
    value: 'bilateral'
  },
  {
    label: 'Bilateral Maintenance Course - 10 Refills',
    value: 'bilateral_maintenance',
  }
];

export const CASE_STATUS_LISTING: { label: string; value: string | boolean; }[] = [
  {
    label: 'All Cases',
    value: '',
  },
  {
    label: 'Active Cases',
    value: true,
  },
  {
    label: 'Closed Cases',
    value: false,
  },
];

export const TREATMENT_STATUS_LISTING: { label: string; value: string | boolean; }[] = [
  {
    label: 'All Treatments',
    value: '',
  },
  {
    label: 'Active Treatments',
    value: true,
  },
  {
    label: 'Closed Treatments',
    value: false,
  },
];

export const ORDER_STATUS_LISTING: { label: string; value: string | boolean; }[] = [
  {
    label: 'All Orders',
    value: '',
  },
  {
    label: 'Active Orders',
    value: true,
  },
  {
    label: 'Closed Orders',
    value: false,
  },
];

export const CASE_HEADER_LISTING = [
  {
    value: 'id',
    label: 'ID',
  },
  {
    value: 'created_at',
    label: 'Submitted',
  },
  {
    value: 'drug_name',
    label: 'Product',
  },
  {
    value: '',
    label: 'Submitting Practice',
  },
  {
    value: '',
    label: 'Site Of Care'
  },
  {
    value: 'patient_firstlastname',
    label: 'Patient',
  },
  {
    value: 'doctor_firstlastname',
    label: 'Provider',
  },
  {
    value: 'status_name',
    label: 'Status',
  },
  {
    value: '',
    label: 'Next Steps',
  },
  {
    value: '',
    label: 'Patient Actions',
  },
];

export const TREATMENT_HEADER_LISTING = [
  {
    value: 'case_id',
    label: 'Case ID',
  },
  {
    value: '',
    label: 'Instillation',
  },
  {
    value: '',
    label: 'Ordered'
  },
  {
    value: '',
    label: 'Delivery ETA',
  },
  {
    value: '',
    label: 'Patient',
  },
  {
    value: '',
    label: 'Provider',
  },
  {
    value: 'status_name',
    label: 'Treatment Status',
  },
  {
    value: '',
    label: 'Next Steps',
  },
];

export const ORDER_HEADER_LISTING = [
  {
    value: 'id',
    label: 'ID',
  },
  {
    value: 'case_id',
    label: 'Case ID',
  },
  {
    value: 'po_number',
    label: 'Customer PO',
  },
  {
    value: 'user_name',
    label: 'Ordered By',
  },
  {
    value: 'created_at',
    label: 'Ordered Date',
  },
  {
    value: 'completed_at',
    label: 'Completed Date',
  },
  {
    value: '',
    label: 'Status',
  },
];

export const STATE_TREATMENT = [
  {
    value: 'Cost',
    label: 'Cost',
  }, {
    value: 'Off label',
    label: 'Off label',
  }, {
    value: 'PA denied',
    label: 'PA denied',
  }, {
    value: 'Patient refused',
    label: 'Patient refused',
  }, {
    value: 'Step-edits not met',
    label: 'Step-edits not met',
  }, {
    value: 'Unable to contact patient',
    label: 'Unable to contact patient',
  }, {
    value: 'Other',
    label: 'Other',
  }
];

export const DRUG_QUANTITY_133mg = [
  {
    value: 1,
    label: "1",
  },
  {
    value: 2,
    label: "2",
  }
];
export const DRUG_QUANTITY_266mg = [
  {
    value: 1,
    label: "1",
  }
];

export const INSURANCE_POLICY = [
  {
    value: "Medical",
    label: "Medical",
  },
  {
    value: "Dental",
    label: "Dental",
  },
];
export const EOBs_TABLE_HEADER = [
  {
    value: 'id',
    label: 'EOB ID',
  },
  {
    value: '',
    label: 'Claim Date',
  },
  {
    value: '',
    label: 'Product',
  },
   {
    value: '',
    label: 'SOC Type',
  },
  {
    value: '',
    label: 'State',
  },
  {
    value: '',
    label: 'Insurance Name',
  },
  {
    value: '',
    label: 'Insurance Type',
  },
  {
    value: '',
    label: 'Medicare Administrative Contractor (MAC)',
  },
  {
    value: '',
    label: '$ Billed',
  },{
    value: '',
    label: '$ Allowed',
  },{
    value: '',
    label: '$ Paid',
  },
  {
    value: '',
    label: 'Patient Responsibility',
  },
  {
    value:'',
    label:'File'
  },
  {
    value: 'created_at',
    label: 'Created Date',
  },
];
